export default "__VITE_ASSET__1bc37e2e__"